module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.mode === 'image') ? _c('mu-avatar', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.badge.label),
      expression: "badge.label",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "imageBadge",
    attrs: {
      "size": 34,
      "src": _vm.badge.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode === 'text') ? _c('mu-badge', {
    staticClass: "userBadge",
    class: _vm.badge.key,
    attrs: {
      "content": _vm.badge.label
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb22422","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserBadge/UserBadge.vue
// module id = 3213
// module chunks = 1